export const SET_MAP_REFRESH = 'set-map-refresh';
const setMapRefresh = ({ forceMapRefresh }) => ({ type: SET_MAP_REFRESH, payload: { forceMapRefresh } });
export default setMapRefresh;
